import React, {Component} from "react";
import AppHeader from "../../../../AppHeader";

const translate = require('../../../../translate');

const moment = require('moment-timezone');

const Img = ({ name }) => <p><img src={`/images/${name}.png`} className='sign-image' alt={name}/></p>;
const Title = ({ text }) => {
  if (text.length < 10) {
    return <h1 className='title'>{text}</h1>;
  } else {
    return <h1 className='title-small'>{text}</h1>;
  }
};
const Subtitle = ({ text }) => text ? <h2 className='subtitle'>{text}</h2> : null;
const CurrentOccupancyInfo = ({ occupancy, maxOccupancy, language }) => <h2 className='current-occupancy-info'>
  {occupancy >= maxOccupancy ? (
    translate(language, 'Maximum capacity ({0}) reached.', [maxOccupancy])
  ) : (
    translate(language, 'Current occupancy: {0}/{1}', [occupancy, maxOccupancy])
  )}
</h2>;
const Container = ({ imageName, children }) => {
  return <div className='columns semaphore-container'>
    <div className='column col-4 text-center'>
      {imageName && <Img name={imageName} />}
    </div>
    <div className='column col-8'>
      <div className='text-container'>
        {children}
      </div>
    </div>
  </div>;
}

const EnterState = ({ occupancy, maxOccupancy, language, hideNumbers }) => {
  let text = translate(language, 'ENTER');
  let diff = maxOccupancy - occupancy;
  let info = diff > 10 ?
    null :
    <span dangerouslySetInnerHTML={{__html: translate(language, '{0} person(s) may enter.', [`<b>${diff}</b>`])}} />;

  return <Container imageName='arrow'>
    <Title text={text} />
    {info && !hideNumbers ? <Subtitle text={info} /> : null}
    {hideNumbers ? null : <CurrentOccupancyInfo occupancy={occupancy} maxOccupancy={maxOccupancy} language={language} />}
  </Container>;
};

const WaitState = ({ occupancy, maxOccupancy, language, hideNumbers }) => {
  return <Container imageName='hand'>
    <Title text={translate(language, 'STOP')} />
    <Subtitle text={translate(language, 'Wait, please.')} />
    {hideNumbers ? null : <CurrentOccupancyInfo occupancy={occupancy} maxOccupancy={maxOccupancy} language={language} />}
  </Container>;
};

const WithoutLimits = ({ occupancy, language }) => {
  return <Container>
    <h2 className='current-occupancy-info'>
      { translate(language, 'Current occupancy: {0}', [occupancy]) }
    </h2>
  </Container>;
}

const Closed = ({ language }) => {
  return <Container imageName='hand'>
    <h1 className='closed-title'>{translate(language, 'CLOSED')}</h1>
  </Container>;
};

const InformativeEnterState = ({ occupancy, maxOccupancy, language }) => {
  let text = translate(language, 'ENTER');

  return <Container imageName='arrow'>
    <Title text={text} />
    <CurrentOccupancyInfo occupancy={occupancy} maxOccupancy={maxOccupancy} language={language} />
  </Container>;
};

const InformativeFullState = ({ occupancy, maxOccupancy, language }) => {
  return <Container imageName='arrow'>
    <Subtitle text={translate(language, 'Maximum capacity reached.')} />
    <h2 className='current-occupancy-info'>
      {translate(language, 'Current occupancy: {0}/{1}', [occupancy, maxOccupancy])}
    </h2>
  </Container>;
};

export class Legacy extends Component {

  render() {
    let {hideNumbers, data, connectionStatus, language, screen, background} = this.props;
    let meta = this.props.metadata;
    let timeZone = meta.timeZone || "UTC";

    document.body.style.backgroundColor = background;

    let content = null;
    if (screen === 'closed') {
      content = <Closed language={language}/>;
    } else if (screen === 'withoutLimits') {
      content = <WithoutLimits occupancy={data.currentOccupancy} language={language}/>
    } else if (screen === 'informativeFullState') {
      content = <InformativeFullState maxOccupancy={data.maxOccupancy} occupancy={data.currentOccupancy}
                                      language={language}/>;
    } else if (screen === 'informativeEnterState') {
      content = <InformativeEnterState maxOccupancy={data.maxOccupancy} occupancy={data.currentOccupancy}
                                       language={language}/>;
    } else if (screen === 'waitState') {
      content = <WaitState maxOccupancy={data.maxOccupancy} occupancy={data.currentOccupancy}
                           language={language} hideNumbers={hideNumbers}/>;
    } else if (screen === 'enterState') {
      content = <EnterState maxOccupancy={data.maxOccupancy} occupancy={data.currentOccupancy}
                            language={language} hideNumbers={hideNumbers}/>;
    }

    if (screen === 'errorState') {
      return <h1 style={{color: 'white'}}>{this.props.err}</h1>;
    } else if (screen === 'missingToken') {
      return <h1 style={{color: 'white'}}>Missing token</h1>;
    } else {
      return <div className='text-light'>
        <AppHeader/>
        {content}

        <div className='app-footer'>
          <small>
            {meta.name}, <a href="https://pygmalios.com" className='text-light'>Pygmalios</a>
            {'. '}
            {translate(language, 'Last updated:')} {moment(data.time).tz(timeZone).format('LLL')}
            {'. '}
            {translate(language, 'Connection:')} {connectionStatus}
            {', '}
            {translate(language, 'Current time:')} {moment(this.props.currentTime).tz(timeZone).format('LLL')}
          </small>
        </div>
      </div>;
    }
  }
}
